module.exports = __webpack_public_path__ + "static/media/data-1.ac73e7fe.jpg";